// Top-level navigation configuration for The Academic Boardroom.
// `quad` opens the standalone campus experience on the live custom domain in
// a new tab (visitors get the fresh full-viewport view). All other tiles are
// still locked and trigger the Under Construction modal.

export const NAV_ITEMS = [
  {
    id: "quad",
    label: "Campus Quad",
    path: "/",
    locked: false,
    externalUrl: "http://boardroom-immersive.emergent.host/quad",
  },
  { id: "studio",    label: "Studio",      path: "/studio",    locked: true  },
  { id: "lounge",    label: "Lounge",      path: "/lounge",    locked: true  },
  { id: "boardroom", label: "Boardroom",   path: "/boardroom", locked: true  },
  { id: "merch",     label: "Merch",       path: "/merch",     locked: true  },
];

// Mapping from a locked path to the human-readable area name shown in the modal.
export const LOCKED_AREAS = {
  studio:    "Studio",
  lounge:    "Lounge",
  boardroom: "Boardroom",
  merch:     "Merch",
};
